module.exports = __webpack_public_path__ + "img/moqing.4eab5900.png";